import styled from 'styled-components';
import { colors } from '../../constant';

export const ErrorMessage = styled.div`
  display: flex;
  word-break: break-word;
  font-size: 11px;
  color: ${colors.red};
`;
